<template lang="html">
  <div class="feature">
    <img :src="require('../assets/beers/beer_id-' + beer.id + '.jpg')" alt="" onerror="this.src='http:///i.imgur.com/hfM1J8s.png'">
    <img src="a-missing-image.jpg" alt="" >
    <div class="content">
      <h2 class="title">{{beer.name}}</h2>
      <p class="meta">Drukket d. {{displayDate}}</p>
      <p class="meta">Rating: {{beer.rating}}</p>
      <div class="truncate-overflow">
        <p class="text">
           {{beer.comment}}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    beer: Object
  },
  computed: {
    displayDate: function() {
      return new Date(this.beer.date).toLocaleString('da', {dateStyle: 'long', timeStyle: 'short'});
    }
  }
}
</script>

<style lang="css" scoped>

.feature {
    width: 100%;

    border-radius: 4px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.3);
    text-align: left;
    margin-bottom: 20px;
}
.truncate-overflow{
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
  overflow: hidden;
}

/* .truncate-overflow {
  --max-lines: 2;
  --lh: 1.4rem;
  position: relative;
  max-height: calc(var(--lh) * var(--max-lines));
  overflow: hidden;
  padding-right: 1rem; /* space for ellipsis
}
/* .truncate-overflow::before {
  position: absolute;
  content: "...";
  bottom: 0;
  right: 0;
}
.truncate-overflow::after {
  content: "";
  position: absolute;
  right: 0;
  width: 1rem;
  height: 1rem;
  background: white;
}  */



.content{
  padding: 20px;
}

.meta {
  font-size: 0.8em;
  margin-bottom: 1em;
}
.text{

}

img {
  width: 100%;
  height: 200px;
  object-fit: cover;
}


h2{
  margin: 0;
  padding: 0;
}
p{
  margin: 0;
}

</style>
